export function numberWithCommas(number: number | string): string {
  return String(number).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export function fullWidthToHalfWidthSpace(text: string): string {
  return text.replace(/\u3000/g, " ");
}

export function percentageOneDecimal(num: number, total: number): number {
  return total !== 0 ? Math.floor((num / total) * 1000) / 10 : 0;
}
